/**
 * A client's recorded pronouns as the forms a sentence needs, all lower
 * case. A caller that starts a sentence with one capitalises it. Pronouns
 * not recorded read "this client".
 */

import type { ClientPronouns } from '@/lib/clientRecord';

export interface PronounForms {
  /** 'she' | 'he' | 'they' | 'this client' */
  subject: string;
  /** 'her' | 'him' | 'them' | 'this client' */
  object: string;
  /** 'her' | 'his' | 'their' | "this client's" */
  possessive: string;
  /** True only for they/them, for verb agreement. */
  plural: boolean;
}

const GENERIC: PronounForms = {
  subject: 'this client',
  object: 'this client',
  possessive: "this client's",
  plural: false,
};

const FORMS: Readonly<Record<ClientPronouns, PronounForms>> = {
  'she/her': { subject: 'she', object: 'her', possessive: 'her', plural: false },
  'he/him': { subject: 'he', object: 'him', possessive: 'his', plural: false },
  'they/them': { subject: 'they', object: 'them', possessive: 'their', plural: true },
};

export function pronounForms(p: ClientPronouns | null | undefined): PronounForms {
  const forms = p == null ? undefined : FORMS[p];
  return forms === undefined ? { ...GENERIC } : { ...forms };
}
